var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Box, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CommonCardView from '../../components/uiComponents/CommonCardView';
import CreditScoreCard from '../../components/uiComponents/CreditScoreCard';
import { baseColors } from '../../Themes/colors';
import OverviewReviewHeader from './components/overview/OverviewReviewHeader';
import { SectionCard, StatusPill } from './BacklogApplicationStyles';
import { ReasonsChipList, toContractNoticeItems, toSourcedReasons } from './components/ReasonsNoticePreview';
import { useDocsBackReasons } from './components/useDocsBackReasons';
import { parseStatusReasonUdf } from '../../utils/statusReasonUdf';
var UnionIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 20 : _b;
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M13.1895 7.37747C13.5679 6.99911 14.1812 6.99911 14.5595 7.37747C14.9379 7.75582 14.9379 8.36911 14.5595 8.74746L10.4004 12.9066C9.64363 13.6628 8.41691 13.6631 7.66036 12.9066L5.43885 10.6851C5.06063 10.3069 5.06091 9.69353 5.43885 9.31514C5.8172 8.93679 6.43049 8.93679 6.80885 9.31514L9.03036 11.5367L13.1895 7.37747Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25069 1.36576C8.63148 -0.455255 11.3688 -0.455255 12.7496 1.36576C13.0799 1.80105 13.6198 2.02484 14.1612 1.95047C16.4251 1.63944 18.3611 3.57516 18.0498 5.83906C17.9756 6.38052 18.199 6.92046 18.6345 7.25069C20.455 8.63158 20.4553 11.3689 18.6345 12.7496C18.1989 13.0799 17.9754 13.6196 18.0498 14.1612C18.3607 16.4249 16.4249 18.3607 14.1612 18.0498C13.6196 17.9754 13.0799 18.1989 12.7496 18.6345C11.3689 20.4553 8.63158 20.455 7.25069 18.6345C6.92046 18.199 6.38052 17.9756 5.83906 18.0498C3.57516 18.3611 1.63944 16.4251 1.95047 14.1612C2.02484 13.6198 1.80105 13.0799 1.36576 12.7496C-0.455255 11.3688 -0.455255 8.63148 1.36576 7.25069C1.8012 6.92048 2.02466 6.38045 1.95047 5.83906C1.63918 3.57504 3.57504 1.63918 5.83906 1.95047C6.38045 2.02466 6.92048 1.8012 7.25069 1.36576ZM11.2055 2.53613C10.6001 1.73805 9.40019 1.73805 8.79477 2.53613C8.04149 3.52952 6.81018 4.03975 5.57509 3.87017C4.58241 3.73368 3.73368 4.58241 3.87017 5.57509C4.03975 6.81018 3.52952 8.04149 2.53613 8.79477C1.73805 9.40019 1.73805 10.6001 2.53613 11.2055C3.52938 11.9589 4.03992 13.1901 3.87017 14.4252C3.73394 15.4177 4.58253 16.2666 5.57509 16.1301C6.81024 15.9605 8.04147 16.4707 8.79477 17.4642C9.40029 18.2617 10.6002 18.262 11.2055 17.4642C11.9589 16.4706 13.1899 15.9603 14.4252 16.1301C15.4175 16.2662 16.2662 15.4175 16.1301 14.4252C15.9603 13.1899 16.4706 11.9589 17.4642 11.2055C18.262 10.6002 18.2617 9.40029 17.4642 8.79477C16.4707 8.04147 15.9605 6.81024 16.1301 5.57509C16.2666 4.58253 15.4177 3.73394 14.4252 3.87017C13.1901 4.03992 11.9589 3.52938 11.2055 2.53613Z", fill: "currentColor" })));
};
var AiReviewTooltip = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, __assign({}, props, { arrow: true, classes: { popper: className }, placement: "top" })));
})(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: baseColors.bluePreset[10],
            color: baseColors.fullWhite,
            borderRadius: 8,
            boxShadow: '0 10px 24px rgba(0,0,0,0.24)',
            padding: '14px 18px',
            minWidth: 250,
        },
        _a["& .".concat(tooltipClasses.arrow)] = {
            color: baseColors.bluePreset[10],
        },
        _a);
});
var RangeCardRoot = styled(Stack)(function () { return ({
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: baseColors.fullWhite,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 12,
    padding: '12px 16px',
    gap: 12,
    width: '100%',
}); });
var RangeIconWrapper = styled(Box)(function () { return ({
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: baseColors.greyPreset[55],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg, & span': {
        fontSize: 20,
        color: baseColors.darkPreset[10],
    },
}); });
var CreditScoreRangeCard = function (_a) {
    var label = _a.label, low = _a.low, high = _a.high, _b = _a.min, min = _b === void 0 ? 300 : _b, _c = _a.max, max = _c === void 0 ? 850 : _c;
    var range = max - min;
    var lowPct = ((low - min) / range) * 100;
    var highPct = ((high - min) / range) * 100;
    return (React.createElement(RangeCardRoot, null,
        React.createElement(RangeIconWrapper, null,
            React.createElement("span", { className: "icon-Dashboard" })),
        React.createElement(Stack, { flex: 1, gap: 0.5 },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[30] }, label),
                React.createElement(Typography, { variant: "body2", fontWeight: 700, color: baseColors.darkPreset[10] }, low),
                React.createElement(Typography, { variant: "body2", fontWeight: 700, color: baseColors.darkPreset[10] }, high)),
            React.createElement(Box, { sx: { position: 'relative', height: 6, borderRadius: 3, backgroundColor: baseColors.greyPreset[45] } },
                React.createElement(Box, { sx: {
                        position: 'absolute',
                        left: "".concat(lowPct, "%"),
                        width: "".concat(highPct - lowPct, "%"),
                        height: '100%',
                        borderRadius: 3,
                        backgroundColor: baseColors.successPreset[40],
                    } }),
                React.createElement(Box, { sx: {
                        position: 'absolute',
                        left: "".concat(lowPct, "%"),
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: baseColors.successPreset[40],
                    } }),
                React.createElement(Box, { sx: {
                        position: 'absolute',
                        left: "".concat(highPct, "%"),
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        backgroundColor: baseColors.successPreset[40],
                    } })),
            React.createElement(Box, { sx: { display: 'flex', justifyContent: 'space-between' } },
                React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30] }, min),
                React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[30] }, max)))));
};
var ENTITY_FIELD_CONFIGS = [
    { icon: React.createElement("span", { className: "icon-person" }), label: 'Name:', fieldKey: 'Name', reportValueKey: 'LegalName' },
    { icon: React.createElement("span", { className: "icon-location" }), label: 'Main Address:', fieldKey: 'Address', reportValueKey: 'PrimaryAddress' },
    { icon: React.createElement("span", { className: "icon-location" }), label: 'Billing Address:', fieldKey: 'BillingAddress', reportValueKey: 'PrimaryAddress' },
    { icon: React.createElement("span", { className: "icon-Date" }), label: 'DOB:', fieldKey: 'DOB', reportValueKey: 'DOB' },
    { icon: React.createElement("span", { className: "icon-call" }), label: 'Phone:', fieldKey: 'PhoneNumber', reportValueKey: 'PhoneNumber' },
];
var GUARANTOR_FIELD_CONFIGS = [
    { icon: React.createElement(UnionIcon, null), label: 'Name:', fieldKey: 'Name', reportValueKey: 'LegalName' },
    { icon: React.createElement("span", { className: "icon-location" }), label: 'Main Address:', fieldKey: 'Address', reportValueKey: 'PrimaryAddress' },
    { icon: React.createElement("span", { className: "icon-Date" }), label: 'DOB:', fieldKey: 'DOB', reportValueKey: 'DOB' },
    { icon: React.createElement("span", { className: "icon-call" }), label: 'Phone:', fieldKey: 'PhoneNumber', reportValueKey: 'PhoneNumber' },
];
var toDisplayText = function (value) {
    if (value === null || value === undefined)
        return '--';
    if (typeof value === 'string')
        return value.trim() || '--';
    if (typeof value === 'number' || typeof value === 'boolean')
        return String(value);
    if (Array.isArray(value)) {
        var joined = value.map(toDisplayText).filter(function (v) { return v !== '--'; }).join(', ');
        return joined || '--';
    }
    return '--';
};
var toBoolean = function (value) {
    if (typeof value === 'boolean')
        return value;
    if (typeof value === 'number')
        return value === 1;
    if (typeof value === 'string') {
        var n = value.trim().toLowerCase();
        if (['true', '1', 'yes'].includes(n))
            return true;
        if (['false', '0', 'no'].includes(n))
            return false;
    }
    return undefined;
};
var toPercentage = function (value) {
    if (typeof value === 'number' && Number.isFinite(value))
        return value;
    if (typeof value === 'string') {
        var n = Number(value.replace('%', '').trim());
        if (Number.isFinite(n))
            return n;
    }
    return undefined;
};
var maskSSN = function (value) {
    if (!value || value === '--')
        return value;
    var digits = value.replace(/\D/g, '');
    if (digits.length < 3)
        return value;
    return "****-****-".concat(digits.slice(-3));
};
var formatPhoneNumber = function (value) {
    if (!value || value === '--')
        return value;
    var digits = value.replace(/\D/g, '');
    if (digits.length === 10)
        return "".concat(digits.slice(0, 3), "-").concat(digits.slice(3, 6), "-").concat(digits.slice(6));
    if (digits.length === 11 && digits.startsWith('1'))
        return "".concat(digits.slice(1, 4), "-").concat(digits.slice(4, 7), "-").concat(digits.slice(7));
    return value;
};
var normaliseToArray = function (value) {
    if (!value)
        return [];
    return Array.isArray(value) ? value : [value];
};
var buildEntityFieldCard = function (entity, config, ssnLabel) {
    var _a;
    var fieldObject = entity === null || entity === void 0 ? void 0 : entity[config.fieldKey];
    var label = (config.fieldKey === 'SSN' && ssnLabel) ? ssnLabel : config.label;
    var systemValue = toDisplayText(fieldObject === null || fieldObject === void 0 ? void 0 : fieldObject[config.fieldKey]);
    if (config.fieldKey === 'SSN')
        systemValue = maskSSN(systemValue);
    if (config.fieldKey === 'PhoneNumber')
        systemValue = formatPhoneNumber(systemValue);
    var reportDataArr = Array.isArray((_a = fieldObject === null || fieldObject === void 0 ? void 0 : fieldObject.Summary) === null || _a === void 0 ? void 0 : _a.ReportData)
        ? fieldObject.Summary.ReportData
        : [];
    var allMatched = reportDataArr.length > 0 && reportDataArr.every(function (e) { return toBoolean(e.Match) === true; });
    var badge = reportDataArr.length > 0
        ? (allMatched ? MATCHED_BADGE : REVIEW_BADGE)
        : undefined;
    var tooltipContent = reportDataArr.length > 0 ? (React.createElement(Stack, { gap: 1.5, sx: { maxWidth: 280 } }, reportDataArr.map(function (entry, i) {
        var _a, _b, _c;
        var reportType = toDisplayText((_b = (_a = entry.ReportType) !== null && _a !== void 0 ? _a : entry.BureauCode) !== null && _b !== void 0 ? _b : null);
        var percentage = toPercentage(entry.Percentage);
        var percentageLabel = Number.isFinite(percentage) ? "".concat(percentage, "%") : '';
        var isEntryMatched = (_c = toBoolean(entry.Match)) !== null && _c !== void 0 ? _c : false;
        var statusLabel = isEntryMatched ? 'MATCH' : 'REVIEW';
        var reportValue = toDisplayText(entry[config.reportValueKey]);
        var headerText = reportType !== '--'
            ? "".concat(reportType.toUpperCase()).concat(percentageLabel ? " - ".concat(percentageLabel) : '', " ").concat(statusLabel)
            : "".concat(percentageLabel ? "".concat(percentageLabel, " ") : '').concat(statusLabel);
        return (React.createElement(Stack, { key: i, gap: 0.5 },
            React.createElement(Stack, { direction: "row", gap: 1.25, alignItems: "flex-start" },
                React.createElement(Stack, { alignItems: "center", justifyContent: "flex-start" },
                    React.createElement(InfoOutlinedIcon, { sx: {
                            fontSize: 16,
                            color: baseColors.fullWhite,
                            flexShrink: 0,
                            mt: 0.2,
                        } })),
                React.createElement(Stack, { direction: "column", gap: 0.5 },
                    React.createElement(Typography, { variant: "caption", fontWeight: 700, fontSize: 13, color: baseColors.fullWhite, lineHeight: 1.4 }, headerText),
                    React.createElement(Typography, { variant: "caption", color: baseColors.fullWhite, lineHeight: 1.6 }, "System: ".concat(systemValue)),
                    React.createElement(Typography, { variant: "caption", color: baseColors.fullWhite, lineHeight: 1.6 }, "Report: ".concat(reportValue))))));
    }))) : (React.createElement(Stack, { gap: 0.5, sx: { maxWidth: 280 } },
        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75 },
            React.createElement(InfoOutlinedIcon, { sx: { fontSize: 16, color: baseColors.fullWhite, flexShrink: 0 } }),
            React.createElement(Typography, { variant: "caption", fontWeight: 700, fontSize: 13, color: baseColors.fullWhite }, "No Report Data")),
        React.createElement(Typography, { variant: "caption", color: baseColors.fullWhite, lineHeight: 1.6 }, "System: ".concat(systemValue))));
    return { icon: config.icon, label: label, resolvedValue: systemValue, badge: badge, tooltip: tooltipContent };
};
var buildEntityCards = function (entity, ssnLabel, showDOB) {
    if (showDOB === void 0) { showDOB = true; }
    return ENTITY_FIELD_CONFIGS
        .filter(function (config) { return showDOB || config.fieldKey !== 'DOB'; })
        .map(function (config) { return buildEntityFieldCard(entity, config, ssnLabel); });
};
var buildGuarantorCards = function (entity, ssnLabel, showDOB) {
    if (showDOB === void 0) { showDOB = true; }
    return GUARANTOR_FIELD_CONFIGS
        .filter(function (config) { return showDOB || config.fieldKey !== 'DOB'; })
        .map(function (config) { return buildEntityFieldCard(entity, config, ssnLabel); });
};
var REVIEW_BADGE = {
    label: 'Review',
    icon: React.createElement("span", { className: "icon-Warning" }),
};
var MATCHED_BADGE = {
    label: 'Matched',
    icon: React.createElement("span", { className: "icon-Circle_Check" }),
    bgColor: baseColors.successPreset[60],
    borderColor: baseColors.successPreset[70],
    color: baseColors.successPreset[40],
    labelColor: baseColors.successPreset[50],
};
var fallbackSections = [
    {
        title: 'Customer Summary',
        sectionitem: 'CustomerInfo',
        phone: 'Johnmwalker@gmail.com',
        cards: [
            { icon: React.createElement("span", { className: "icon-person" }), label: 'Name:', value: 'BusinessName', badge: REVIEW_BADGE },
            { icon: React.createElement("span", { className: "icon-location" }), label: 'Main Address:', value: 'Address', badge: MATCHED_BADGE },
            { icon: React.createElement("span", { className: "icon-location" }), label: 'Billing Address:', value: 'BillingAddress', badge: REVIEW_BADGE },
            { icon: React.createElement("span", { className: "icon-account" }), label: 'SSN:', value: 'SSN', badge: MATCHED_BADGE },
            { icon: React.createElement("span", { className: "icon-call" }), label: 'Phone:', value: 'PhoneNumber', badge: MATCHED_BADGE },
        ],
    },
    {
        title: 'Guarantor Summary',
        sectionitem: 'CustomerInfo',
        phone: 'sarahw@gmail.com',
        cards: [
            { icon: React.createElement("span", { className: "icon-person" }), label: 'Name:', value: 'Sarah Walker', badge: MATCHED_BADGE },
            { icon: React.createElement("span", { className: "icon-location" }), label: 'Main Address:', value: '5534 98th Ter, Live Oak, FL 32060-7222, USA', badge: MATCHED_BADGE },
            { icon: React.createElement("span", { className: "icon-call" }), label: 'Phone:', value: '386-209-8858', badge: MATCHED_BADGE },
            { icon: React.createElement("span", { className: "icon-account" }), label: 'SSN:', value: '****-****-124', badge: MATCHED_BADGE },
        ],
    },
    {
        title: 'Other Details Summary',
        sectionitem: 'CustomerInfo',
        cards: [
            { icon: React.createElement("span", { className: "icon-Tractor" }), label: 'Equipment:', value: 'Wheelchair X200' },
        ],
        creditScores: [
            { label: 'Equifax Score', score: 750, progress: 72 },
            { label: 'PayNet Score', score: 768, progress: 77 },
        ],
    },
];
var creditStatuses = [
    {
        label: 'Credit approved',
        icon: React.createElement("span", { className: "icon-Circle_Check" }),
        color: baseColors.fullWhite,
        bgColor: baseColors.successPreset[40],
    },
];
var contractStatuses = [
    {
        label: 'Contract 30 approved',
        color: '#D98F00',
        bgColor: '#F5F0BC',
    },
];
var creditReviewReason = 'Comparable credit paid as agreed, Dealer support, Equipment holds value well, Excellent Credit Bureau Score, Good cash flow, Good collateral, High D&B PAYDEX score, Low leverage, Personal Guarantor support, Strong management team, Sufficient Cash Flow, Years of Experience.';
var contractStatusReason = {
    paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna',
};
var BacklogAppOverview = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
    var appResp = _a.appResp, mainResp = _a.mainResp, roleType = _a.roleType, UDFsData = _a.UDFsData, aiReviewData = _a.aiReviewData, creditReport = _a.creditReport, assetResp = _a.assetResp, _6 = _a.isDocumentPreviewOpen, isDocumentPreviewOpen = _6 === void 0 ? false : _6;
    var primaryApplicant = normaliseToArray((_b = mainResp === null || mainResp === void 0 ? void 0 : mainResp.RelatedAccounts) === null || _b === void 0 ? void 0 : _b.CustomerInfo)
        .find(function (acc) { return (acc === null || acc === void 0 ? void 0 : acc.IsPrimary) === 1 || (acc === null || acc === void 0 ? void 0 : acc.IsPrimary) === '1' || (acc === null || acc === void 0 ? void 0 : acc.IsPrimary) === true; });
    var contractStatusName = String((_d = (_c = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _c === void 0 ? void 0 : _c.ContractStatus) !== null && _d !== void 0 ? _d : '');
    var showsContractStatusCard = contractStatusName.startsWith('56 - Docs Back Missing Info')
        || contractStatusName === '39 - Withdrawn'
        || contractStatusName.startsWith('39 - Cancelled');
    var _7 = useDocsBackReasons(showsContractStatusCard), statusReasonCatalogue = _7.reasons, hasLoadedStatusReasonCatalogue = _7.hasLoaded;
    var isDocsBackMissingInfoStatus = contractStatusName.startsWith('56 - Docs Back Missing Info');
    var contractStatusReasonItems = React.useMemo(function () {
        var _a;
        var contractReasons = toSourcedReasons((_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _a === void 0 ? void 0 : _a.StatusReasons)
            .filter(function (reason) { var _a; return isDocsBackMissingInfoStatus || String((_a = reason.source) !== null && _a !== void 0 ? _a : '').trim().toUpperCase() !== 'HUB'; });
        var items = toContractNoticeItems(contractReasons, hasLoadedStatusReasonCatalogue ? statusReasonCatalogue : undefined);
        if (isDocsBackMissingInfoStatus)
            return items;
        return __spreadArray(__spreadArray([], items, true), parseStatusReasonUdf(UDFsData === null || UDFsData === void 0 ? void 0 : UDFsData.StatusReason).map(function (text) { return ({ text: text }); }), true);
    }, [(_e = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _e === void 0 ? void 0 : _e.StatusReasons, UDFsData === null || UDFsData === void 0 ? void 0 : UDFsData.StatusReason, statusReasonCatalogue, hasLoadedStatusReasonCatalogue, isDocsBackMissingInfoStatus]);
    var IsPrimaryApplicant = (primaryApplicant === null || primaryApplicant === void 0 ? void 0 : primaryApplicant.CustomerAspireOId) ? String(primaryApplicant.CustomerAspireOId) : '--';
    var CreditReport = normaliseToArray(creditReport).find(function (report) { var _a; return String((_a = report === null || report === void 0 ? void 0 : report.CustomerOId) !== null && _a !== void 0 ? _a : '') === IsPrimaryApplicant; });
    var rangeCardData = CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.ApproxReportScoreRange;
    var _8 = (_f = rangeCardData === null || rangeCardData === void 0 ? void 0 : rangeCardData.split('-').map(Number)) !== null && _f !== void 0 ? _f : [0, 0], min = _8[0], max = _8[1];
    var Progress = (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.FicoScore) ? (CreditReport.FicoScore / 850) * 100 : 0;
    var progressPaynet = (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore) ? (CreditReport.MasterScore / 850) * 100 : 0;
    var hasCreditScoreData = [CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.FicoScore, CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore]
        .some(function (score) { return score !== null && score !== undefined && String(score).trim() !== ''; });
    var getEntityFromApiNode = function (value) {
        var _a;
        if (!value)
            return null;
        if (Array.isArray(value))
            return (_a = value.find(Boolean)) !== null && _a !== void 0 ? _a : null;
        return value;
    };
    var overviewSections = React.useMemo(function () {
        var _a, _b, _c;
        var primaryApplicantEntity = getEntityFromApiNode(aiReviewData === null || aiReviewData === void 0 ? void 0 : aiReviewData.PrimaryApplicant);
        var coApplicantEntity = getEntityFromApiNode(aiReviewData === null || aiReviewData === void 0 ? void 0 : aiReviewData.CoApplicant);
        var primaryGuarantorEntity = getEntityFromApiNode((_a = aiReviewData === null || aiReviewData === void 0 ? void 0 : aiReviewData.PrimaryGuarantor) !== null && _a !== void 0 ? _a : aiReviewData === null || aiReviewData === void 0 ? void 0 : aiReviewData.Guarantor);
        var coGuarantorEntity = getEntityFromApiNode(aiReviewData === null || aiReviewData === void 0 ? void 0 : aiReviewData.CoGuarantor);
        var financeProgramDescription = (_c = (_b = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _b === void 0 ? void 0 : _b.FinanceProgramDescription) !== null && _c !== void 0 ? _c : '';
        var isConsumer = financeProgramDescription.toLowerCase().includes('consumer');
        var ssnLabel = isConsumer ? 'SSN#/TIN#/SIN#:' : 'FED TAX ID/BN#:';
        var showDOB = isConsumer;
        var assets = normaliseToArray(assetResp === null || assetResp === void 0 ? void 0 : assetResp.Assets);
        var assetsWithContent = assets.filter(function (asset) {
            var _a;
            var hasDescription = String((_a = asset === null || asset === void 0 ? void 0 : asset.Description) !== null && _a !== void 0 ? _a : '').trim() !== '';
            var hasQuantity = (asset === null || asset === void 0 ? void 0 : asset.Quantity) !== null && (asset === null || asset === void 0 ? void 0 : asset.Quantity) !== undefined && String(asset === null || asset === void 0 ? void 0 : asset.Quantity).trim() !== '';
            return hasDescription || hasQuantity;
        });
        var equipmentValue = assetsWithContent.length > 0
            ? assetsWithContent.map(function (asset) {
                var desc = asset.Description || '--';
                var qty = asset.Quantity != null ? "(".concat(asset.Quantity, ")") : '';
                return "".concat(desc).concat(qty);
            }).join(', ')
            : '--';
        var hasAssetData = assetsWithContent.length > 0;
        var shouldShowOtherDetailsSummary = hasAssetData || hasCreditScoreData;
        var otherDetailsSection = __assign(__assign({}, fallbackSections[2]), { cards: hasAssetData
                ? [
                    { icon: React.createElement("span", { className: "icon-Tractor" }), label: 'Equipment:', value: equipmentValue },
                ]
                : [] });
        if (!primaryApplicantEntity && !coApplicantEntity && !primaryGuarantorEntity && !coGuarantorEntity) {
            return shouldShowOtherDetailsSummary ? [otherDetailsSection] : [];
        }
        var customerRecords = [primaryApplicantEntity, coApplicantEntity]
            .filter(Boolean)
            .map(function (entity) { return ({
            cards: buildEntityCards(entity, ssnLabel, showDOB),
        }); });
        var guarantorRecords = [primaryGuarantorEntity, coGuarantorEntity]
            .filter(Boolean)
            .map(function (entity) { return ({
            cards: buildGuarantorCards(entity, ssnLabel, showDOB),
        }); });
        var groupedSections = [];
        var hasCustomerRecords = customerRecords.length > 0;
        var hasGuarantorRecords = guarantorRecords.length > 0;
        var hasMultiCustomerAndGuarantor = customerRecords.length > 1 && guarantorRecords.length > 1;
        if (customerRecords.length > 0) {
            groupedSections.push({
                title: 'Customer Summary',
                cards: [],
                records: customerRecords,
            });
        }
        if (guarantorRecords.length > 0) {
            groupedSections.push({
                title: 'Guarantor Summary',
                cards: [],
                records: guarantorRecords,
            });
        }
        if (shouldShowOtherDetailsSummary) {
            if (hasMultiCustomerAndGuarantor && hasCustomerRecords) {
                groupedSections.splice(1, 0, otherDetailsSection);
            }
            else if (hasGuarantorRecords) {
                groupedSections.push(otherDetailsSection);
            }
            else {
                groupedSections.push(otherDetailsSection);
            }
        }
        return groupedSections;
    }, [aiReviewData, assetResp, mainResp, hasCreditScoreData]);
    return (React.createElement(Box, { display: "flex", flexDirection: "column", gap: 2 },
        React.createElement(OverviewReviewHeader, { title: "Pre-Docs AI Review", description: "Runs when the application form is received from the customer", hasResults: false, canDecide: false, showActions: false }),
        React.createElement(Grid, { container: true, spacing: 2, alignItems: "stretch" },
            React.createElement(Grid, { item: true, xs: 12, lg: ((_h = (_g = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _g === void 0 ? void 0 : _g.ContractStatus) === null || _h === void 0 ? void 0 : _h.startsWith('56 - Docs Back Missing Info')) || ((_j = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _j === void 0 ? void 0 : _j.ContractStatus) === '39 - Withdrawn' || ((_l = (_k = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _k === void 0 ? void 0 : _k.ContractStatus) === null || _l === void 0 ? void 0 : _l.startsWith('39 - Cancelled')) ? 6 : 12, sx: { display: 'flex' } },
                React.createElement(SectionCard, { sx: { flex: 1 } },
                    React.createElement(Box, { sx: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
                        React.createElement(Typography, { variant: "h6", color: baseColors.darkPreset[10] }, "Credit Status"),
                        React.createElement(Box, { sx: { display: 'flex', gap: 1, flexWrap: 'wrap' } }, ((_m = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _m === void 0 ? void 0 : _m.CreditDecision) && (React.createElement(StatusPill, { sx: {
                                backgroundColor: ((_o = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _o === void 0 ? void 0 : _o.CreditDecision) === 'Approved'
                                    ? baseColors.successPreset[40]
                                    : ((_p = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _p === void 0 ? void 0 : _p.CreditDecision) === 'Declined'
                                        ? '#C92000'
                                        : baseColors.greyPreset[45],
                            } },
                            React.createElement(Typography, { variant: "body2", fontWeight: 600, color: ((_q = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _q === void 0 ? void 0 : _q.CreditDecision) === 'Approved' ? baseColors.fullWhite : baseColors.darkPreset[10] }, (_r = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _r === void 0 ? void 0 : _r.CreditDecision))))),
                    React.createElement(Stack, { gap: 0.6 },
                        React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[10] }, "Credit Review Reason:"),
                        React.createElement(Box, { component: "ul", sx: { m: 0, pl: 2.5 } }, (((_s = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _s === void 0 ? void 0 : _s.CreditReviewReasons) && (mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData.CreditReviewReasons.length) > 0) ?
                            (_t = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _t === void 0 ? void 0 : _t.CreditReviewReasons.map(function (item, idx) { return (React.createElement(Typography, { component: "li", variant: "body2", key: idx, color: baseColors.greyPreset[10] }, item.Description)); })
                            : React.createElement(Typography, { variant: "body2", color: baseColors.greyPreset[10] }, "--"))))),
            (((_v = (_u = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _u === void 0 ? void 0 : _u.ContractStatus) === null || _v === void 0 ? void 0 : _v.startsWith('56 - Docs Back Missing Info')) || ((_w = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _w === void 0 ? void 0 : _w.ContractStatus) === '39 - Withdrawn' || ((_y = (_x = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _x === void 0 ? void 0 : _x.ContractStatus) === null || _y === void 0 ? void 0 : _y.startsWith('39 - Cancelled'))) && (React.createElement(Grid, { item: true, xs: 12, lg: 6, sx: { display: 'flex' } },
                React.createElement(SectionCard, { sx: { flex: 1, border: 1, borderColor: ((_0 = (_z = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _z === void 0 ? void 0 : _z.ContractStatus) === null || _0 === void 0 ? void 0 : _0.startsWith('56')) ? '#DDBF17' : '#C92000', } },
                    React.createElement(Box, { sx: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
                        React.createElement(Typography, { variant: "h6", color: baseColors.darkPreset[10] }, "Contract Status"),
                        React.createElement(Box, { sx: { display: 'flex', gap: 1, flexWrap: 'wrap' } },
                            React.createElement(StatusPill, { sx: {
                                    backgroundColor: ((_2 = (_1 = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _1 === void 0 ? void 0 : _1.ContractStatus) === null || _2 === void 0 ? void 0 : _2.startsWith('56')) ? '#F5F0BC' : '#FFCABA',
                                } },
                                React.createElement(Typography, { variant: "body2", fontWeight: 600, color: ((_4 = (_3 = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _3 === void 0 ? void 0 : _3.ContractStatus) === null || _4 === void 0 ? void 0 : _4.startsWith('56')) ? '#D98F00' : '#C92000' }, (_5 = mainResp === null || mainResp === void 0 ? void 0 : mainResp.ContractData) === null || _5 === void 0 ? void 0 : _5.ContractStatus)))),
                    React.createElement(Stack, { gap: 0.6 },
                        React.createElement(Typography, { variant: "caption", color: baseColors.greyPreset[10] }, "Contract Status Reason"),
                        React.createElement(ReasonsChipList, { items: contractStatusReasonItems })))))),
        (function () {
            var hasMultipleRecords = overviewSections.some(function (s) { var _a, _b; return ((_b = (_a = s.records) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 1; });
            var useExplicit3Col = hasMultipleRecords && !isDocumentPreviewOpen;
            var gridTemplateColumns = useExplicit3Col
                ? 'repeat(3, minmax(0, 1fr))'
                : hasMultipleRecords
                    ? 'repeat(auto-fill, minmax(min(100%, 400px), 1fr))'
                    : 'repeat(auto-fill, minmax(min(100%, 300px), 1fr))';
            return (React.createElement(Box, { sx: {
                    display: 'grid',
                    gap: 2,
                    gridTemplateColumns: gridTemplateColumns,
                    alignItems: 'stretch',
                    minWidth: 0,
                    width: '100%',
                } }, overviewSections.map(function (section, sectionIndex) {
                var _a, _b;
                return (React.createElement(Box, { key: "".concat(section.title, "-").concat(sectionIndex), sx: {
                        display: 'flex',
                        minWidth: 0,
                        gridColumn: useExplicit3Col && ((_b = (_a = section.records) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 1 ? 'span 2' : undefined,
                    } },
                    React.createElement(SectionCard, { sx: { flex: 1 } },
                        React.createElement(Typography, { variant: "h6", color: baseColors.darkPreset[10] }, section.title),
                        section.records && section.records.length > 0 ? (React.createElement(Box, { sx: {
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 2,
                                alignItems: 'start',
                            } }, section.records.map(function (record, recordIndex) { return (React.createElement(Stack, { key: "".concat(section.title, "-record-").concat(recordIndex), gap: 1, sx: { flex: '1 1 180px', minWidth: 0 } }, record.cards.map(function (card, idx) {
                            var _a;
                            return ('resolvedValue' in card ? (React.createElement(CommonCardView, { key: idx, icon: card.icon, label: card.label, resolvedValue: card.resolvedValue, badge: card.badge, tooltip: card.tooltip })) : (React.createElement(CommonCardView, __assign({ key: idx }, card, { mainResp: (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.RelatedAccounts) === null || _a === void 0 ? void 0 : _a[section.sectionitem] }))));
                        }))); }))) : (React.createElement(Stack, { gap: 1 }, section.cards.map(function (card, idx) {
                            var _a;
                            return ('resolvedValue' in card ? (React.createElement(CommonCardView, { key: idx, icon: card.icon, label: card.label, resolvedValue: card.resolvedValue, badge: card.badge, tooltip: card.tooltip })) : (React.createElement(CommonCardView, __assign({ key: idx }, card, { mainResp: (_a = mainResp === null || mainResp === void 0 ? void 0 : mainResp.RelatedAccounts) === null || _a === void 0 ? void 0 : _a[section.sectionitem] }))));
                        }))),
                        section.title === 'Other Details Summary' && ((CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.FicoScore) || (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore)) && (React.createElement(React.Fragment, null,
                            React.createElement(Typography, { variant: "body2", fontWeight: 500, color: baseColors.darkPreset[10] }, "Credit Score"),
                            roleType === ("SALES_SUPPORT" || "INT_SALESREP" || "SALES_MANAGER")
                                ? (React.createElement(Stack, { gap: 1 },
                                    React.createElement(React.Fragment, null,
                                        (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.FicoScore) &&
                                            React.createElement(CreditScoreRangeCard, { key: 1, label: 'Equifax Score', low: min, high: max }),
                                        (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore) &&
                                            React.createElement(CreditScoreCard, { key: 1, icon: React.createElement("span", { className: "icon-Dashboard" }), label: 'PayNet Score', score: CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore, progress: progressPaynet })))) : (React.createElement(Stack, { gap: 1 },
                                (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.FicoScore) &&
                                    React.createElement(CreditScoreCard, { key: 1, icon: React.createElement("span", { className: "icon-Dashboard" }), label: 'Equifax Score', score: CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.FicoScore, progress: Progress }),
                                (CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore) &&
                                    React.createElement(CreditScoreCard, { key: 1, icon: React.createElement("span", { className: "icon-Dashboard" }), label: 'PayNet Score', score: CreditReport === null || CreditReport === void 0 ? void 0 : CreditReport.MasterScore, progress: progressPaynet }))))))));
            })));
        })()));
};
export default BacklogAppOverview;
